import React from 'react';
import classnames from 'classnames/bind';
import style from './index.module.scss';
import ReactPaginate from 'react-paginate';

interface IPaginatorProps {
  index: number;
  total: number;
  changeIndexHandler: (value: number) => void;
}

interface IEvent {
  selected: number;
}

const cx = classnames.bind(style);

function Paginator(props: IPaginatorProps) {
  const {index, changeIndexHandler, total} = props;
  const pageChange = (event: IEvent) => {
    changeIndexHandler(event.selected);
  };
  return (
    <>
      {total > 1 && (
        <div data-testid="pagination" className={cx('paginator')}>
          <ReactPaginate
            initialPage={index}
            pageCount={total}
            pageRangeDisplayed={1}
            marginPagesDisplayed={2}
            onPageChange={pageChange}
          />
        </div>
      )}
    </>
  );
}

export default Paginator;
